import { render, staticRenderFns } from "./SupplyChainReport.vue?vue&type=template&id=0d20865d&scoped=true&"
import script from "./SupplyChainReport.vue?vue&type=script&lang=js&"
export * from "./SupplyChainReport.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChainReport.vue?vue&type=style&index=0&id=0d20865d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20865d",
  null
  
)

export default component.exports